import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import 'intersection-observer'; // Polyfill for IntersectionObserver
import useIsInViewport from 'use-is-in-viewport';
import useImpressionImpl from './useImpressionImpl';

/**
 * The web platform provides ways for elements to identify for themselves when
 * they are visible on screen. This hook is a simple wrapper around
 * `useImpressionImpl` that uses the `IntersectionObserver` API to set the
 * `isVisible` flag for that hook. The `ref` property on the return value of
 * this hook should be attached to the component being tracked via its `ref`
 * prop.
 */
var useImpression = function useImpression(_ref) {
  var eventType = _ref.eventType,
    elementName = _ref.elementName,
    entityName = _ref.entityName,
    payload = _ref.payload,
    refireOnEventChange = _ref.refireOnEventChange;
  var _useIsInViewport = useIsInViewport(),
    _useIsInViewport2 = _slicedToArray(_useIsInViewport, 2),
    isInViewport = _useIsInViewport2[0],
    ref = _useIsInViewport2[1];
  var impression = useImpressionImpl({
    eventType: eventType,
    elementName: elementName,
    entityName: entityName,
    payload: payload,
    isVisible: isInViewport,
    refireOnEventChange: refireOnEventChange
  });
  return _objectSpread(_objectSpread({}, impression), {}, {
    ref: ref
  });
};
export default useImpression;